// Centralized route constants — use these instead of hardcoded strings
export const ROUTES = {
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  DASHBOARD: '/',
  CATTLE: '/cattle',
  CATTLE_DETAIL: '/cattle/:id',
  PASTURES: '/pastures',
  PASTURE_DETAIL: '/pastures/:id',
  FEEDLOTS: '/feedlots',
  FEEDLOT_DETAIL: '/feedlots/:id',
  HAY_FIELD_INFO: '/hay-field-info',
  HAY_FIELD_INFO_DETAIL: '/hay-field-info/:id',
  HAY_FIELDS: '/hay-fields',
  HAY_FIELD_DETAIL: '/hay-fields/:id',
  EQUIPMENT: '/equipment',
  EQUIPMENT_DETAIL: '/equipment/:id',
  VET_VISITS: '/vet-visits',
  BREEDING_RECORDS: '/breeding-records',
  MEDICATIONS: '/medications',
  CHORES: '/chores',
  USERS: '/users',
  PROFILE: '/profile',
  SETTINGS: '/settings',
  VACCINATION_PROTOCOLS: '/vaccination-protocols',
  GRAZING_ROTATIONS: '/grazing-rotations',
  DOCUMENTS: '/documents',
  REPORTS: '/reports',
  ANALYTICS: '/analytics',
  MAP: '/map',
  CALCULATORS: '/calculators',
  BULK_OPERATIONS: '/bulk-operations',
  BREED_SUBMISSIONS: '/breed-submissions',
  CATTLE_GROUPS: '/cattle-groups',
  CATTLE_GROUP_DETAIL: '/cattle-groups/:id',
  BREEDING_PLANS: '/breeding-plans',
  ADMIN: '/admin',
};

// Auth-exempt routes (no ProtectedRoute wrapper)
export const PUBLIC_ROUTES = [ROUTES.LOGIN, ROUTES.FORGOT_PASSWORD, ROUTES.RESET_PASSWORD];

// Helper to build detail routes
export const cattleDetail = (id) => `/cattle/${id}`;
export const pastureDetail = (id) => `/pastures/${id}`;
export const feedlotDetail = (id) => `/feedlots/${id}`;
export const hayFieldInfoDetail = (id) => `/hay-field-info/${id}`;
export const hayFieldDetail = (id) => `/hay-fields/${id}`;
export const equipmentDetail = (id) => `/equipment/${id}`;
export const cattleGroupDetail = (id) => `/cattle-groups/${id}`;
